export enum EPerformanceChartSerieName {
    Units = 0,
    Revenue = 1,
}